export default "__VITE_ASSET__D5Ryv7oF__"